import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import CommonStoryCard from "../../../molecules/common-story-card";
import getStoriesByCollection from "../../../../utils";
import "./subscription-collection.m.css";
export const SubscriptionCollection = ({ data }) => {
  const subscriptionCollection = data.collection;
  const collection = get(subscriptionCollection, ["collection"], {});
  const stories = getStoriesByCollection(collection);
  if (stories && stories.length < 1) {
    return null;
  }
  return (
    <div styleName="subscription-collection-wrapper">
      {collection.summary && <h2 styleName="summary">{collection.summary}</h2>}
      <div styleName="subscription-collection">
        {stories.slice(0, 6).map((story, index) => {
          return <CommonStoryCard story={story} key={index} showSection={true} />;
        })}
      </div>
    </div>
  );
};
SubscriptionCollection.propTypes = {
  data: PropTypes.object
};
SubscriptionCollection.storyLimit = 6;
